/** Formats a demo prepaid-token string in the visual style of an STS
 *  (Standard Transfer Specification) token: 20 digits, grouped in 4s.
 *
 *  This is deliberately NOT in services/mock/ — it isn't fake business
 *  data, it's a stand-in for a capability (a real electricity vending
 *  provider) that isn't connected yet. vendingService uses this in both
 *  its mock and real branches, since the wallet debit + transaction record
 *  can be real (via Supabase) even while the token itself is still a
 *  placeholder. Delete this and generate real tokens from the vending
 *  API's response once that integration exists. */
export function generateDemoTokenDigits(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  let digits = "";
  let s = hash || 1;
  for (let i = 0; i < 20; i++) {
    s = (s * 1103515245 + 12345) >>> 0;
    digits += String(s % 10);
  }
  const grouped = digits.match(/.{1,4}/g);
  return grouped ? grouped.join(" ") : digits;
}
